import * as React from 'react';
import { useIntl } from 'react-intl';
import { withStyles, WithStyles } from '@material-ui/core';
import {
  Domain as AddressIcon,
  Person as PersonIcon,
  Phone as PhoneIcon,
  Videocam as VideoIcon,
} from '@material-ui/icons';

import { TAppointment } from 'ui-model';
import { Typography, TypographyWithIcon } from 'components/v2';

import messages from './AppointmentItemContent.messages';
import styles from './AppointmentItemContent.styles';

interface IAppointmentItemContent extends WithStyles<typeof styles> {
  appointment: TAppointment;
}

const AppointmentItemContent = (props: IAppointmentItemContent) => {
  const { appointment, classes } = props;
  const { formatMessage } = useIntl();

  const isTelehealth = appointment.type.modality === 'telehealth';

  if (isTelehealth) {
    return (
      <TypographyWithIcon
        icon={<VideoIcon className={classes.icon} />}
        variant="bW600F14"
        noWrap
        className={classes.typography}
      >
        {formatMessage(messages.onlineAppointment)}
      </TypographyWithIcon>
    );
  }

  const facilityPhoneNumber = appointment.facility.phone || '';
  const formattedFacilityPhoneNumber = facilityPhoneNumber.replace(/\+1 /, '');

  return (
    <div>
      <TypographyWithIcon
        className={classes.typography}
        icon={<AddressIcon className={classes.icon} />}
        noWrap
        variant="bW600F14"
      >
        <Typography variant="bW600F14" noWrap className={classes.typography}>
          {appointment.facility.name || '...'}
        </Typography>
        <Typography variant="bW600F14" noWrap className={classes.typography}>
          {appointment.facility.address || '...'}
        </Typography>
      </TypographyWithIcon>
      <TypographyWithIcon
        className={classes.typography}
        icon={<PhoneIcon className={classes.icon} />}
        noWrap
        variant="bW600F14"
      >
        {formattedFacilityPhoneNumber}
      </TypographyWithIcon>
      <TypographyWithIcon
        className={classes.typography}
        icon={<PersonIcon className={classes.icon} />}
        noWrap
        variant="bW600F14"
      >
        {appointment.provider.name || ''}
      </TypographyWithIcon>
    </div>
  );
};

export default withStyles(styles)(AppointmentItemContent);
